import { render, TemplateResult } from 'lit';

export class Portal {
  private container: HTMLDivElement | null = null;
  private id: string;

  constructor(id: string) {
    this.id = id;
  }

  render(template: TemplateResult) {
    if (!this.container) {
      this.container = document.createElement('div');
      this.container.id = this.id;
      document.body.appendChild(this.container);
    }
    render(template, this.container);
  }

  clear() {
    if (this.container) {
      this.container.remove();
      this.container = null;
    }
  }
}
